import { EventNames, EventSources } from '../enums';

export interface IBaseEventArgs {
  EventName: EventNames;
  EventSource: EventSources;
}
